Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.LastOperationStatus = module.exports.default = {
	BUFFER_OVERFLOW_ERROR: "bufferOverflowError",
	ERROR_CODE_UNKNOWN: "errorCodeUnknown",
	ILLEGAL_ARGUMENT_ERROR: "illegalArgumentError",
	INDEX_OUT_OF_BOUNDS_ERROR: "indexOutOfBoundsError",
	INVALID_ATTR_VALUE: "invalidAttrValue",
	INVALID_CHAR_FOUND: "invalidCharFound",
	MEMORY_ALLOCATION_ERROR: "memoryAllocationError",
	NO_ERROR: "noError",
	NUMBER_OVERFLOW_ERROR: "numberOverflowError",
	PARSE_ERROR: "parseError",
	PATTERN_SYNTAX_ERROR: "patternSyntaxError",
	PLATFORM_API_FAILED: "platformAPIFailed",
	TRUNCATED_CHAR_FOUND: "truncatedCharFound",
	UNEXPECTED_TOKEN: "unexpectedToken",
	UNSUPPORTED_ERROR: "unsupportedError",
	USING_DEFAULT_WARNING: "usingDefaultWarning",
	USING_FALLBACK_WARNING: "usingFallbackWarning",
};